import { Button } from 'antd';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { GetCampaignStats } from '../../../apis/Admin/Home/GetCampaignStats';
import { useGlobalState } from '../../../store/state';
import './CampaignStatsComponent.styles.scss';

const CampaignStatsComponent = ({ className }) => {
  const [user] = useGlobalState('user');
  const [camps, setCamps] = useState([]);

  const getCounts = () => {
    GetCampaignStats(user.accessToken).then(({ response, status }) => {
      if (status === 200) {
        const newArr = response.filter((camp) => {
          if (camp._id === 'review') {
            return camp;
          } else if (camp._id === 'published') {
            return camp;
          } else if (camp._id === 'active') {
            return camp;
          } else if (camp._id === 'pendingpayment') {
            return camp;
          } else {}
        });
        setCamps(newArr);
      }
    });
  };

  useEffect(() => {
    getCounts();
  }, []);

  return (
    <div className={`${className}`}>
      <div className="common_card admin_stats_camps p-3 h-100">
        <div className="admin_stats_camps_top d-md-flex d-flex-wrap">
          <div className="col-md-5 p-0">
            <h4>Campaigns Overview</h4>
          </div>
          <div className="col-md-7 text-right p-0">
            <Button className="common_button">Create Campaign</Button>
          </div>
        </div>
        <div className="admin_stats_camps_cards">
          {
            camps.map(({ _id, count, status }) => (
              <div key={_id}
                className="admin_stats_camps_cards_each">
                <h5>In {status} <Link className="common_button outlined py-1"
                  to="/admin/dashboard/campaigns">View</Link></h5>
                <h4>{count || 0}<span>Campaigns</span></h4>
                {/* <p>Latest 2.30 PM</p> */}
                <p>Latest n/a</p>
              </div>
            ))
          }

          {/* <div className="admin_stats_camps_cards_each">
                        <h5>In Review <Button className="common_button outlined py-1">View</Button></h5>
                        <h4>14<span>Campaigns</span></h4>
                        <p>Latest 2.30 PM</p>
                    </div>
                    <div className="admin_stats_camps_cards_each">
                        <h5>In Approved <Button className="common_button outlined py-1">View</Button></h5>
                        <h4>2<span>Campaigns</span></h4>
                        <p>In Pending Payments</p>
                    </div>
                    <div className="admin_stats_camps_cards_each">
                        <h5>Published <Button className="common_button outlined py-1">View</Button></h5>
                        <h4>4<span>Campaigns</span></h4>
                        <p>50+ Influencer submissions</p>
                    </div>
                    <div className="admin_stats_camps_cards_each">
                        <h5>Active <Button className="common_button outlined py-1">View</Button></h5>
                        <h4>2<span>Campaigns</span></h4>
                        <p>10+ Influencer link shares</p>
                    </div> */}
        </div>
      </div>
    </div>
  );
};

export default CampaignStatsComponent;
